<div class="flex-auto gt-xs:pr-3 w-full min-w-0 mb-2">
  <label class="block text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label">
    <span class="text-ellipsis overflow-hidden pointer-events-auto" [matTooltip]="fieldDef.label" tooltipIfEllipsis>
      {{ fieldDef.label }}
      @if (isRequired) {
        <span class="text-red-500">*</span>
      }
    </span>
  </label>
  <div
    *ngIf="options && options.length >= 0"
    class="ts-select-wrapper"
    [ngClass]="{ disabled: isDisabled }"
    TsFieldStyling
    [fieldBackgroundColor]="fieldStyling().color"
    [fieldBold]="fieldStyling().is_bold"
    [targetStylingClass]="tsSelectTargetStylingClass"
    style="max-width: 100%"
  >
    <ts-select
      [testId]="'form-field-' + fieldDef.name"
      [ngModel]="value"
      [tooltip]="value"
      [listItemTooltip]="true"
      (ngModelChange)="onSelectionChange($event)"
      [name]="fieldDef.name"
      [items]="options"
      [itemKey]="itemKey"
      [itemLabel]="itemLabel"
      [multi]="multiple"
      [multiDisplayMode]="'comma'"
      [disabled]="isDisabled"
      [uiOptions]="{
        placeholder: 'Select...',
        searchPlaceholder: 'Search...',
      }"
      #selectControl="ngModel"
    >
    </ts-select>
    @if (isRequired && selectControl.invalid && selectControl.touched) {
      <div class="text-red-500 text-xs mt-1">{{ fieldDef.label }} is required.</div>
    }
  </div>
</div>
